import {
    Component,
    inject,
    OnInit,
    output,
    signal,
    ChangeDetectionStrategy,
} from '@angular/core'
import { RouterModule } from '@angular/router'
import {
    AuthStateService,
    UserOrganizationStateService,
} from '@baboor/baboor-auth'
import { ProfileStateService } from '@baboor/baboor-user'
import { Organization } from '@baboor/common-auth'
import { EasyProfileDropdownComponent } from '../easy-profile-dropdown/easy-profile-dropdown.component'
import { HeaderQuickSettingsComponent } from '../header-quick-settings/header-quick-settings.component'

@Component({
    selector: 'app-easy-header-default',
    imports: [
        RouterModule,

        EasyProfileDropdownComponent,
        HeaderQuickSettingsComponent,
    ],
    templateUrl: './easy-header-default.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './easy-header-default.component.scss',
})
export class EasyHeaderDefaultComponent implements OnInit {
    protected profileStateService = inject(ProfileStateService)
    protected authStateService = inject(AuthStateService)
    protected userGroupStateService = inject(UserOrganizationStateService)

    sidebarToggle = output<void>()
    organization = signal<Organization | null>(null)

    toggleSidebar() {
        this.sidebarToggle.emit()
    }

    ngOnInit(): void {
        this.profileStateService.init()
        this.userGroupStateService.init(0)
        this.getOrganization()
    }

    private getOrganization() {
        this.organization.set(this.authStateService.getOrganization() ?? null)
    }
}
